import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class HomeTripState {
  readonly active$ = new BehaviorSubject(false);
  seed: any;
  singleSearch: any;
  private browser: boolean;
  constructor(@Inject(PLATFORM_ID) platform: object) {
    this.browser = isPlatformBrowser(platform);
    if (this.browser) try { this.active$.next(sessionStorage.getItem('hh-home-trip-mode') === 'true'); } catch {}
  }
  open(seed?: any) {
    this.seed = seed;
    if(seed && !seed.routeId)this.singleSearch = seed;
    this.active$.next(true);
    if (this.browser) try { sessionStorage.setItem('hh-home-trip-mode', 'true'); } catch {}
  }
  close() {
    this.active$.next(false); this.seed = undefined;
    if (this.browser) try { sessionStorage.removeItem('hh-home-trip-mode'); } catch {}
  }
}
